import { IFoThucDonImportRequest, IFoThucDonInsertMultipleRequest, IFoThucDonSelectRequest } from "../../../api/dich-vu/food/foThucDonApi";
import { fo_caan } from "../../../models/response/dich-vu/food/fo_caan";
import { fo_monan_chitiet } from "../../../models/response/dich-vu/food/fo_monan_chitiet";
import { FoThucDonTheoNgayItemResponse } from "../../../models/response/dich-vu/food/fo_thucdon";
import {
	eFoThucDonActionTypeIds,
	IFoThucDonChangeMonAn,
	IFoThucDonChangeMonAnPayload,
	IFoThucDonCloseImportModal,
	IFoThucDonImportErr,
	IFoThucDonImportStart,
	IFoThucDonImportSuccess,
	IFoThucDonLoadCaAnErr,
	IFoThucDonLoadCaAnStart,
	IFoThucDonLoadCaAnSuccess,
	IFoThucDonLoadErr,
	IFoThucDonLoadMonAnErr,
	IFoThucDonLoadMonAnStart,
	IFoThucDonLoadMonAnSuccess,
	IFoThucDonLoadStart,
	IFoThucDonLoadSuccess,
	IFoThucDonSaveMultipleErr,
	IFoThucDonSaveMultipleStart,
	IFoThucDonSaveMultipleSuccess,
	IFoThucDonShowImportModal,
	IFoThucDonValidateImportErr,
	IFoThucDonValidateImportStart,
	IFoThucDonValidateImportSuccess
} from "../../action-types/dich-vu/IFoThucDonActionTypes";

export const foThucDonActions = {
	loadFoThucDonStart: (request: IFoThucDonSelectRequest): IFoThucDonLoadStart => {
		return {
			type: eFoThucDonActionTypeIds.LOAD_START,
			payload: request
		}
	},
	loadFoThucDonSuccess: (data?: FoThucDonTheoNgayItemResponse): IFoThucDonLoadSuccess => {
		return {
			type: eFoThucDonActionTypeIds.LOAD_SUCCESS,
			payload: data
		}
	},
	loadFoThucDonError: (message: string): IFoThucDonLoadErr => {
		return {
			type: eFoThucDonActionTypeIds.LOAD_ERROR,
			payload: message
		}
	},
	loadFoCaAnStart: (): IFoThucDonLoadCaAnStart => {
		return {
			type: eFoThucDonActionTypeIds.LOAD_CAAN_START
		}
	},
	loadFoCaAnSuccess: (data: fo_caan[]): IFoThucDonLoadCaAnSuccess => {
		return {
			type: eFoThucDonActionTypeIds.LOAD_CAAN_SUCCESS,
			payload: data
		}
	},
	loadFoCaAnError: (message: string): IFoThucDonLoadCaAnErr => {
		return {
			type: eFoThucDonActionTypeIds.LOAD_CAAN_ERROR,
			payload: message
		}
	},
	loadFoMonAnChiTietStart: (dm_coso_id: number): IFoThucDonLoadMonAnStart => {
		return {
			type: eFoThucDonActionTypeIds.LOAD_MONAN_START,
			payload: dm_coso_id
		}
	},
	loadFoMonAnChiTietSuccess: (data: fo_monan_chitiet[]): IFoThucDonLoadMonAnSuccess => {
		return {
			type: eFoThucDonActionTypeIds.LOAD_MONAN_SUCCESS,
			payload: data
		}
	},
	loadFoMonAnChiTietError: (message: string): IFoThucDonLoadMonAnErr => {
		return {
			type: eFoThucDonActionTypeIds.LOAD_MONAN_ERROR,
			payload: message
		}
	},
	changeFoThucDonMonAn: (payload: IFoThucDonChangeMonAnPayload): IFoThucDonChangeMonAn => {
		return {
			type: eFoThucDonActionTypeIds.CHANGE_MONAN,
			payload: payload
		}
	},
	saveFoThucDonMultipleStart: (request: IFoThucDonInsertMultipleRequest): IFoThucDonSaveMultipleStart => {
		return {
			type: eFoThucDonActionTypeIds.SAVE_MULTIPLE_START,
			payload: request
		}
	},
	saveFoThucDonMultipleSuccess: (): IFoThucDonSaveMultipleSuccess => {
		return {
			type: eFoThucDonActionTypeIds.SAVE_MULTIPLE_SUCCESS
		}
	},
	saveFoThucDonMultipleError: (message: string): IFoThucDonSaveMultipleErr => {
		return {
			type: eFoThucDonActionTypeIds.SAVE_MULTIPLE_ERROR,
			payload: message
		}
	},
	showFoThucDonImportModal: (): IFoThucDonShowImportModal => {
		return {
			type: eFoThucDonActionTypeIds.SHOW_IMPORT_MODAL
		}
	},
	closeFoThucDonImportModal: (): IFoThucDonCloseImportModal => {
		return {
			type: eFoThucDonActionTypeIds.CLOSE_IMPORT_MODAL
		}
	},
	validateImportFoThucDonStart: (request: IFoThucDonImportRequest): IFoThucDonValidateImportStart => {
		return {
			type: eFoThucDonActionTypeIds.VALIDATE_IMPORT_START,
			payload: request
		}
	},
	validateImportFoThucDonSuccess: (data: any[]): IFoThucDonValidateImportSuccess => {
		return {
			type: eFoThucDonActionTypeIds.VALIDATE_IMPORT_SUCCESS,
			payload: data
		}
	},
	validateImportFoThucDonError: (message: string): IFoThucDonValidateImportErr => {
		return {
			type: eFoThucDonActionTypeIds.VALIDATE_IMPORT_ERROR,
			payload: message
		}
	},
	importFoThucDonStart: (request: IFoThucDonImportRequest): IFoThucDonImportStart => {
		return {
			type: eFoThucDonActionTypeIds.IMPORT_START,
			payload: request
		}
	},
	importFoThucDonSuccess: (): IFoThucDonImportSuccess => {
		return {
			type: eFoThucDonActionTypeIds.IMPORT_SUCCESS
		}
	},
	importFoThucDonError: (message: string): IFoThucDonImportErr => {
		return {
			type: eFoThucDonActionTypeIds.IMPORT_ERROR,
			payload: message
		}
	}
}
